import { createUUID } from "../fabrix/common/utils/basic-utils";
import { setLoadedModule } from "../fabrix/redux/module-slice";
import { store } from "../fabrix/redux/store";
import { ModuleInfo } from "../fabrix/types";
import modules from "./modules.json";

// Keep these explicit loaders aligned with modules.json. Literal requires keep
// unregistered local checkouts out of the build without Webpack-specific types.
const moduleRouteLoaders: Record<string, () => ModuleInfo> = {
  "afs-module": () => require("./afs-module/routes").default(),
  "afs-module/online-afs": () =>
    require("./afs-module/online-afs/routes").default(),
  "tr-costing": () => require("./tr-costing/routes").default(),
  "document-agent": () => require("./document-agent/routes").default(),
  "security-management": () => require("./security-management/routes").default(),
  utilities: () => require("./utilities/routes").default(),
  notifications: () => require("./notifications/routes").default(),
  "employee-centre": () => require("./employee-centre/routes").default(),
  persal: () => require("./persal/routes").default(),
};

const cleanPath = (path: string) => {
  if (path.startsWith("./"))
    path.substring(2);
  if (path.startsWith("/"))
    path.substring(1);
  return path;
}

export const moduleRoutes = (): ModuleInfo[] => {

  let routes = new Array<ModuleInfo>();

  for (let i = 0; i < modules.length; i++) {
    const module = modules[i] as any;
    if (!module.id) {
      console.error(`System Module: ${module.name} in path: ${module.path} does not have a valid id.`)
      continue;
    }
    try {

      //console.log(`Loading System Module: ${module.name} in path: ${module.path}`)

      const path = cleanPath(module.path)
      const itemProc = moduleRouteLoaders[path];
      if (!itemProc) {
        throw new Error(`No build entry is registered for module: ${path}`);
      }
      let item = itemProc();
      item.id = module.id ?? createUUID();
      item.roles = module.roles;
      item.icon = module.icon;
      item.type = module.type;
      item.image = module.image;
      item.services = module.services ?? [];
      routes.push(item)
      store.dispatch(setLoadedModule(item.name));
    } catch (ex) {
      console.error(`System Module: ${module.name} in path: ${module.path} was not found or did not load correctly.`)
    }
  }
  return routes
}
